import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clientsAPI } from '../services/api';

export const useClients = () => {
  const queryClient = useQueryClient();

  // Get all clients
  const {
    data: clients = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['clients'],
    queryFn: clientsAPI.getAll,
  });

  // Create client mutation
  const createClient = useMutation({
    mutationFn: clientsAPI.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  // Update client mutation
  const updateClient = useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => 
      clientsAPI.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  // Delete client mutation
  const deleteClient = useMutation({
    mutationFn: clientsAPI.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  return {
    clients,
    isLoading,
    error,
    refetch,
    createClient: createClient.mutate,
    updateClient: updateClient.mutate,
    deleteClient: deleteClient.mutate,
    isCreating: createClient.isPending,
    isUpdating: updateClient.isPending,
    isDeleting: deleteClient.isPending,
  };
};

export const useClient = (id: string) => {
  const {
    data: client,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['client', id],
    queryFn: () => clientsAPI.getById(id),
    enabled: !!id,
  });

  return {
    client,
    isLoading,
    error,
    refetch,
  };
};
